<template>
    <section class="flex-container my-4">
        <h4 class="font-semibold">Rota</h4>
        <div class="divide-y divide-dashed divide-gray-300">
            <div class="flex items-center pb-1">
                <Icone :nome="'location_on'" :classesAdicionais="['text-green-500']" />
                <span class="">{{ enderecoOrigem }}</span>
            </div>
            <div class="flex items-center pt-1">
                <Icone :nome="'location_on'" :classesAdicionais="['text-red-500']" />
                <span class="">{{ enderecoDestino }}</span>
            </div>
        </div>
    </section>
</template>

<script>
import { defineComponent } from 'vue';
import Icone from '@/components/Icone.vue';

export default defineComponent({
    name: 'InfoAtendimento',
    components: {
        Icone
    },
    props: {
        enderecoOrigem: {
            type: String,
            required: true
        },
        enderecoDestino: {
            type: String,
            required: true
        }
    }
});
</script>